// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import ACCOUNT_CONSTANTS from '@tcp/core/src/components/features/account/Account/Account.constants';
import AccountOverviewTile from '../../../../../../common/molecules/AccountOverviewTile';
import internalEndpoints from '../../../internalEndpoints';
import MyFavoriteTileItem from '../molecules/MyFavoriteTileItem';
import ContactPreferencesTileItem from '../molecules/ContactPreferencesTileItem';
import SocialAccountsTileItem from '../molecules/SocialAccountsTileItem';
import { isCanada, isSNJ } from '../../../../../../../utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import AccountCommonLabels, { ACCOUNT_LABELS } from '../../../labels/AccountCommon.labels';

export const MyPreferencesTile = ({
  favStoreName,
  favStoreAddress,
  favStoreState,
  favStoreCity,
  favStoreZipcode,
  favStorePhone,
  socialAccounts,
  customerPreferences,
}) => {
  const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);

  const clickEventdata = {
    customEvents: [],
    eventName: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationName.overview_viewPreferences,
    pageNavigationText: ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS.navigationText.overview_viewPreferences,
  };
  return (
    <AccountOverviewTile
      title={renderLabel(
        accountLabels?.preferences?.lbl_prefrence_heading,
        'lbl_prefrence_heading'
      )}
      ctaTitle={renderLabel(
        accountLabels?.preferences?.lbl_prefrence_view_preferences,
        'lbl_prefrence_view_preferences'
      )}
      dataLocatorPrefix="orders"
      ctaLink={internalEndpoints.myPreferencesPage.link}
      ctaPath={internalEndpoints.myPreferencesPage.path}
      clickEventdata={clickEventdata}
    >
      <MyFavoriteTileItem
        favStoreName={favStoreName}
        favStoreAddress={favStoreAddress}
        favStoreState={favStoreState}
        favStoreCity={favStoreCity}
        favStoreZipcode={favStoreZipcode}
        favStorePhone={favStorePhone}
        isSNJ={isSNJ()}
      />

      {!isCanada() ? (
        <>
          <ContactPreferencesTileItem customerPreferences={customerPreferences} />
          <SocialAccountsTileItem socialAccounts={socialAccounts} />
        </>
      ) : null}
    </AccountOverviewTile>
  );
};

MyPreferencesTile.propTypes = {
  ordersList: PropTypes.shape({}).isRequired,
  favStoreName: PropTypes.string,
  favStoreAddress: PropTypes.string,
  favStoreState: PropTypes.string,
  favStoreCity: PropTypes.string,
  favStoreZipcode: PropTypes.string,
  favStorePhone: PropTypes.string,
  socialAccounts: PropTypes.shape({}),
  customerPreferences: PropTypes.shape({}),
};

MyPreferencesTile.defaultProps = {
  favStoreName: '',
  favStoreState: '',
  favStoreCity: '',
  favStoreZipcode: '',
  favStorePhone: '',
  favStoreAddress: '',
  socialAccounts: {},
  customerPreferences: {},
};

export default MyPreferencesTile;
